import { Box, Divider } from '@wix/design-system';
import React, { FC } from 'react';

import { HelpCenterArticle } from '../../types';
import { isArticleVotable } from '../../utils';
import { ArticleVoteButton } from '../ArticleVoteButton';
import { articleFooterDataHooks } from './ArticleFooter.dataHooks';

export interface ArticleFooterProps {
  article: HelpCenterArticle;
}

export const ArticleFooter: FC<ArticleFooterProps> = ({ article }) => {
  if (isArticleVotable(article)) {
    return (
      <Box dataHook={articleFooterDataHooks.container()} direction="vertical" gap="SP4">
        <Divider direction="horizontal" />
        <ArticleVoteButton article={article} />
      </Box>
    );
  }
  return null;
};
